import React, { useEffect, useState } from 'react';
import { Mail, KeyRound, ShieldCheck, Loader2 } from 'lucide-react';
import { api } from '../context/AuthContext';

const GoogleIcon = () => <svg viewBox="0 0 24 24" className="w-4 h-4" aria-hidden><path fill="#4285F4" d="M23.5 12.3c0-.8-.1-1.6-.2-2.3H12v4.4h6.5a5.6 5.6 0 0 1-2.4 3.6v3h3.9c2.2-2.1 3.5-5.1 3.5-8.7z" /><path fill="#34A853" d="M12 24c3.2 0 6-1.1 7.9-2.9l-3.9-3c-1.1.7-2.4 1.2-4 1.2-3.1 0-5.7-2.1-6.6-4.9H1.4v3.1A12 12 0 0 0 12 24z" /><path fill="#FBBC05" d="M5.4 14.4a7.2 7.2 0 0 1 0-4.7V6.6h-4a12 12 0 0 0 0 10.9l4-3.1z" /><path fill="#EA4335" d="M12 4.8c1.7 0 3.3.6 4.6 1.8l3.4-3.4A12 12 0 0 0 1.4 6.6l4 3.1C6.3 6.9 8.9 4.8 12 4.8z" /></svg>;

const Zeile = ({ icon, titel, wert, testid, children }) => (
  <div className="flex flex-wrap items-center gap-3 py-3 border-b border-gray-100 last:border-0" data-testid={testid}>
    <div className="w-10 h-10 bg-[#f5f8fa] rounded-sm flex items-center justify-center shrink-0">{icon}</div>
    <div className="flex-1 min-w-0"><p className="text-[#34536b] text-xs uppercase tracking-wider">{titel}</p><p className="text-[#1B3A5C] font-medium text-sm mt-0.5 break-words">{wert}</p></div>
    {children}
  </div>
);

// Zeigt, mit welchen Adressen und Wegen sich das Konto anmelden kann.
export const Anmeldewege = ({ passwortForm }) => {
  const [d, setD] = useState(null);
  const [link, setLink] = useState('');
  useEffect(() => { api.get('/konto/anmeldewege').then((r) => setD(r.data)).catch(() => setD(false)); }, []);
  if (d === null) return <Loader2 className="w-4 h-4 animate-spin text-[#b8893d]" />;
  if (!d) return null;
  const linkAnfordern = async () => {
    setLink('laden');
    try { await api.post('/auth/password-reset/request', { email: d.email }); setLink('ok'); } catch { setLink('fehler'); }
  };
  return (
    <div data-testid="anmeldewege">
      <Zeile icon={<Mail className="w-4 h-4 text-[#b8893d]" />} titel="Haupt-Adresse" wert={d.email} testid="anmeldeweg-email" />
      <Zeile icon={<GoogleIcon />} titel="Anmeldung mit Google" wert={d.google_emails.length ? d.google_emails.join(', ') : 'nicht verknüpft'} testid="anmeldeweg-google" />
      <Zeile icon={<KeyRound className="w-4 h-4 text-[#b8893d]" />} titel="Anmeldung mit E-Mail und Passwort"
        wert={!d.passwort_moeglich ? 'nicht verfügbar – das Passwort wird bei Google verwaltet' : d.passwort_gesetzt ? `aktiv mit ${d.email}` : 'noch kein Passwort festgelegt'} testid="anmeldeweg-passwort">
        {d.passwort_moeglich && !d.passwort_gesetzt && (link === 'ok'
          ? <span className="text-xs text-emerald-700" data-testid="anmeldeweg-link-gesendet">Link an {d.email} gesendet</span>
          : <button type="button" onClick={linkAnfordern} disabled={link === 'laden'} className="h-9 px-3 rounded-md border border-[#b8893d] text-[#1B3A5C] text-xs disabled:opacity-50" data-testid="anmeldeweg-passwort-festlegen">{link === 'fehler' ? 'Erneut versuchen' : 'Passwort festlegen'}</button>)}
      </Zeile>
      <Zeile icon={<ShieldCheck className="w-4 h-4 text-[#b8893d]" />} titel="Zwei-Faktor-Anmeldung" wert={d.zwei_fa_aktiv ? 'aktiv' : 'nicht eingerichtet'} testid="anmeldeweg-2fa" />
      {d.passwort_moeglich && d.passwort_gesetzt && passwortForm}
    </div>
  );
};
